import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import Input from "@material-ui/core/Input";
import Button2 from "@material-ui/core/Button";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import Preview from "../components/Preview.js";
import * as Yup from "yup";
import { BiCopy } from "react-icons/bi";
import InputAdornment from "@material-ui/core/InputAdornment";


export default function Edit(props) {
  const {
    onHide,
    show,
    notification,
    onNotifications,
    skip,
    take,
    sortField,
    orderBy,
  } = props;
  const {
    id,
    // header,
    // text,
    headerAz,
    headerEn,
    headerRu,
    textAz,
    textEn,
    textRu,
    filePath,
  } = notification;

  const fileUrl = "https://cdn.deyerlisen.az/" + filePath;
  const [file, setFile] = useState("");
  const [preview, setPreview] = useState(true);
  const [imageSrc, setImageSrc] = useState(fileUrl);
  useEffect(() => {
    setImageSrc(fileUrl);
  }, [fileUrl]);

  const [isError, setIsError] = useState("");

  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };

  const form = useRef(null);
  const onPutNotification = (values, resetForm, setSubmitting) => {
    const notification = new FormData(form.current);
    axios
      .put(`${process.env.REACT_APP_API_URL}notification`, notification, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onNotifications(skip, take, sortField, orderBy);
        setPreview(true);
        setImageSrc("");
        setFile("");
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };




  const EditSchema = Yup.object().shape({
    // header: Yup.string().required("Header is required"),
    // text: Yup.string().required("Text is required"),
    headerAz: Yup.string().required("Header Az is required"),
    headerEn: Yup.string().required("Header En is required"),
    headerRu: Yup.string().required("Header Ru is required"),

    textAz: Yup.string().required("Text Az is required"),
    textEn: Yup.string().required("Text En is required"),
    textRu: Yup.string().required("Text Ru is required"),
  });

  const getInputClasses = (touched, errors, FieldName) => {
    if (touched[FieldName] && errors[FieldName]) {
      return true;
    }
    if (touched[FieldName] && errors[FieldName]) {
      return false;
    }

    return false;
  };


  const handleCopyName = (name, values, setFieldValue) => {
    const headerAz = values.headerAz;
    setFieldValue(name, headerAz);
  };

  const handleCopyText = (name, values, setFieldValue) => {
    const textAz = values.textAz;
    setFieldValue(name, textAz);
  };

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="sm"
      aria-labelledby="edit"
      className="modal-right pr-0"
    >
      {notification &&
        Object.keys(notification).length !== 0 &&
        notification.constructor === Object && (
          <Formik
            initialValues={{
              id: id,
              // header: header,
              // text: text,
              headerAz: headerAz,
              headerEn: headerEn,
              headerRu: headerRu,
              textAz: textAz,
              textEn: textEn,
              textRu: textRu,
              filePath: filePath,
            }}
            validationSchema={EditSchema}
            onSubmit={(values, { resetForm, setSubmitting }) => {
              onPutNotification(values, resetForm, setSubmitting);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              handleChange,
              handleBlur,
              resetForm,
              setFieldValue

            }) => (
              <form onSubmit={handleSubmit} ref={form}>
                <Modal.Header closeButton>
                  <Modal.Title id="edit">Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="col-12 pl-4 pr-4">
                    <div className="row">
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          {isError && (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block MuiFormLabel-root Mui-error">
                                {isError}
                              </div>
                            </div>
                          )}
                          <input
                            type="hidden"
                            id="id"
                            name="id"
                            value={values.id}
                          />
                          <TextField
                            id="headerAz"
                            name="headerAz"
                            label="Header Az"
                            placeholder="Header Az"
                            className="w-100"
                            value={values.headerAz}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "headerAz")}
                          />
                        </div>
                        {touched.headerAz && errors.headerAz ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.headerAz}
                            </div>
                          </div>
                        ) : null}
                      </div>


                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="headerEn"
                            name="headerEn"
                            label="Header En"
                            placeholder="Header En"
                            className="w-100"
                            value={values.headerEn}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "headerEn")}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{ cursor: "pointer" }}
                                >
                                  <BiCopy
                                    onClick={() => handleCopyName("headerEn", values, setFieldValue)}
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      color: "grey",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        {touched.headerEn && errors.headerEn ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.headerEn}</div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="headerRu"
                            name="headerRu"
                            label="Header Ru"
                            placeholder="Header Ru"
                            className="w-100"
                            value={values.headerRu}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "headerRu")}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{ cursor: "pointer" }}
                                >
                                  <BiCopy
                                    onClick={() => handleCopyName("headerRu", values, setFieldValue)}
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      color: "grey",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        {touched.headerRu && errors.headerRu ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.headerRu}</div>
                          </div>
                        ) : null}

                      </div>






                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="textAz"
                            name="textAz"
                            label="Text Az"
                            placeholder="Text Az"
                            className="w-100"
                            value={values.textAz}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "textAz")}
                          />
                        </div>
                        {touched.textAz && errors.textAz ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.textAz}
                            </div>
                          </div>
                        ) : null}
                      </div>



                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="textEn"
                            name="textEn"
                            label="Text En"
                            placeholder="Text En"
                            className="w-100"
                            value={values.textEn}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "textEn")}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{ cursor: "pointer" }}
                                >
                                  <BiCopy
                                    onClick={() => handleCopyText("textEn", values, setFieldValue)}
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      color: "grey",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        {touched.textEn && errors.textEn ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.textEn}</div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                          <TextField
                            id="textRu"
                            name="textRu"
                            label="Text Ru"
                            placeholder="Text Ru"
                            className="w-100"
                            value={values.textRu}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={getInputClasses(touched, errors, "textRu")}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{ cursor: "pointer" }}
                                >
                                  <BiCopy
                                    onClick={() => handleCopyText("textRu", values, setFieldValue)}
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      color: "grey",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        {touched.textRu && errors.textRu ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.textRu}</div>
                          </div>
                        ) : null}

                      </div>






                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="w-100 pt-2 pb-3">
                          <label htmlFor="contained-button-file">
                            <Input
                              accept="image/*"
                              id="contained-button-file"
                              type="file"
                              name="file"
                              label="File URL"
                              placeholder="File URL"
                              className="w-100"
                              onChange={imagePreview}
                              value={file}
                              hidden
                            />
                            <Button2 variant="contained" component="span">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Devices/Camera.svg"
                                )}
                                className="mr-2"
                              />
                              Change image
                            </Button2>
                          </label>
                          <Preview
                            preview={preview}
                            imageSrc={imageSrc}
                            onClick={onClick}
                          />
                        </div>
                        {touched.filePath && errors.filePath ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.filePath}
                            </div>
                          </div>
                        ) : null}
                        {isError && (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block MuiFormLabel-root Mui-error">
                              {isError}
                            </div>
                          </div>
                        )}

                      </div>



                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="light"
                    onClick={() => {
                      onHide(false);
                      resetForm();
                    }}
                  >
                    Close
                  </Button>
                  <Button type="submit">Edit</Button>
                </Modal.Footer>
              </form>
            )}
          </Formik>
        )}
    </Modal>
  );
}
